'use strict';

import VideoPlayer from '../utils/video-player';

const Video = {
	els: null,

	init: function () {
		Video.els = document.querySelectorAll('.f-video, .c-headerCaseStudy');

		if ( ! Video.els || Video.els.length === 0 ) {
			return;
		}

		Video.els.forEach( el => Video.managePoster( el ) );
	},

	managePoster: function ( el ) {
		const poster = el.querySelector('.c-video__player-poster');

		if ( ! poster ) {
			return;
		}

		const playerContainer = poster.closest('.c-video__player') || el;

		VideoPlayer.initPoster( poster, playerContainer, {
			playBtnSelector: '.c-video__player-poster-play',
			resetOnPause: false,
		} );
	},
};

export default Video;
